document.addEventListener('DOMContentLoaded', () => {
  // Basic image protection: block right-click save and drag-out-to-save on
  // every image site-wide. Not foolproof (dev tools / screenshots still
  // work) but stops casual right-click / drag saving.
  document.addEventListener('contextmenu', (e) => {
    if (e.target.tagName === 'IMG') e.preventDefault();
  });
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') e.preventDefault();
  });

  // Shared soft crossfade carousel — used on mobile for both the hero triptych
  // and the customer reviews, one panel at a time. Desktop keeps its static
  // grid untouched in both cases (CSS only switches this on <=900px).
  function initCrossfadeCarousel(panelSelector, dotSelector, intervalMs) {
    const panels = document.querySelectorAll(panelSelector);
    const dots = document.querySelectorAll(dotSelector);
    if (panels.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let index = 0;
      setInterval(() => {
        index = (index + 1) % panels.length;
        panels.forEach((p, n) => p.classList.toggle('is-active', n === index));
        dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
      }, intervalMs);
    }
  }

  initCrossfadeCarousel('.hero-panel', '.hero-dot', 5000);
  initCrossfadeCarousel('.review', '.review-dot', 5000);
  initCrossfadeCarousel('.announcement-item', '.announcement-dot', 4000);

  // Mobile nav drawer
  const menuBtn = document.querySelector('.mobile-menu');
  const navClose = document.querySelector('.nav-close');
  const navBackdrop = document.querySelector('.nav-backdrop');
  const openNav = () => { document.body.classList.add('nav-open'); if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true'); };
  const closeNav = () => { document.body.classList.remove('nav-open'); if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false'); };
  if (menuBtn) menuBtn.addEventListener('click', openNav);
  if (navClose) navClose.addEventListener('click', closeNav);
  if (navBackdrop) navBackdrop.addEventListener('click', closeNav);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeNav(); });

  // Tapping any link inside the mobile drawer (Home, category, or submenu
  // links) starts the close animation immediately instead of leaving the
  // drawer sitting open while the browser loads the destination page — the
  // drawer is already sliding shut by the time navigation takes over, so the
  // tap feels instant rather than stuck/laggy.
  document.querySelectorAll('.nav a[href]').forEach(link => {
    link.addEventListener('click', closeNav);
  });

  // Nav & icon submenus: hover-intent with a short close delay, so moving the
  // mouse from the link down into the dropdown doesn't lose it mid-travel.
  document.querySelectorAll('.nav-item.has-submenu, .icon-item.has-submenu').forEach(item => {
    let closeTimer = null;
    item.addEventListener('mouseenter', () => { clearTimeout(closeTimer); item.classList.add('is-open'); });
    item.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => item.classList.remove('is-open'), 300); });
  });

  // Product variant picker: keep the hidden "id" field, price, compare-at
  // price and Add to Cart availability in sync with the selected options.
  document.querySelectorAll('.product-form').forEach(form => {
    const variantsEl = form.querySelector('[data-product-variants]');
    if (!variantsEl) return;
    let variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

    const selects = Array.from(form.querySelectorAll('[data-option-index]'))
      .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex));
    const idInput = form.querySelector('[data-product-select-id]');
    if (!selects.length || !idInput) return;

    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare]');
    const submitBtn = form.querySelector('[data-product-submit]');

    const findVariant = () => {
      const chosen = selects.map(s => s.value);
      return variants.find(v => v.options.every((opt, i) => opt === chosen[i]));
    };

    const sync = () => {
      const variant = findVariant();
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (compareEl) {
        if (variant.compare_at_price) { compareEl.textContent = variant.compare_at_price; compareEl.style.display = ''; }
        else { compareEl.textContent = ''; compareEl.style.display = 'none'; }
      }
      if (submitBtn) { submitBtn.disabled = !variant.available; submitBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out'; }
    };

    selects.forEach(s => s.addEventListener('change', sync));
  });

  // Product row carousels: arrow buttons scroll the track by one card width,
  // plus a slow continuous auto-scroll that stops the moment the visitor
  // interacts (hover, touch, or keyboard focus) and resumes shortly after.
  document.querySelectorAll('.product-row-body').forEach(row => {
    const track = row.querySelector('[data-product-scroll]');
    const prev = row.querySelector('.row-arrow-prev');
    const next = row.querySelector('.row-arrow-next');
    if (!track || !prev || !next) return;

    const step = () => {
      const card = track.querySelector('.product-card');
      const gap = 16;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

    const updateArrows = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = max <= 0 || track.scrollLeft >= max;
    };
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let direction = 1;
      let paused = false;
      let inView = false;
      let resumeTimer = null;
      let rafId = null;

      const tick = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        if (max > 0 && !paused && inView && !document.hidden) {
          if (track.scrollLeft >= max) direction = -1;
          else if (track.scrollLeft <= 0) direction = 1;
          track.scrollLeft += direction * 0.6;
        }
        rafId = requestAnimationFrame(tick);
      };
      rafId = requestAnimationFrame(tick);

      // Only animate while the row is actually on screen — no point spending
      // frames scrolling something the visitor can't see.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
        }, { threshold: 0.15 }).observe(row);
      } else {
        inView = true;
      }

      const pause = () => { paused = true; clearTimeout(resumeTimer); };
      const scheduleResume = () => { resumeTimer = setTimeout(() => { paused = false; }, 1200); };

      row.addEventListener('mouseenter', pause);
      row.addEventListener('mouseleave', scheduleResume);
      row.addEventListener('touchstart', pause, { passive: true });
      row.addEventListener('touchend', scheduleResume);
      row.addEventListener('focusin', pause);
      row.addEventListener('focusout', scheduleResume);
    }
  });

  // Wishlist: signed-in visitors can save/unsave products from the heart on
  // any product card. Saved items persist in this browser (localStorage,
  // scoped to the signed-in customer's id) and render on the dedicated
  // /pages/wishlist page. Signed-out visitors get a small "Sign in to save
  // favorites" bubble instead, matching the rest of the site's toast pattern.
  let activeToast = null;
  function showSignInToast(anchorEl) {
    if (activeToast) { activeToast.el.remove(); clearTimeout(activeToast.timer); activeToast = null; }
    const toast = document.createElement('div');
    toast.className = 'mini-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = 'Sign in to save favorites';
    document.body.appendChild(toast);

    const rect = anchorEl.getBoundingClientRect();
    toast.style.left = (rect.left + window.scrollX + rect.width / 2) + 'px';
    toast.style.top = (rect.top + window.scrollY - toast.offsetHeight - 10) + 'px';

    requestAnimationFrame(() => toast.classList.add('is-visible'));

    const goToSignIn = () => { window.location.href = (window.Decus && window.Decus.loginUrl) || '/account/login'; };
    toast.addEventListener('click', goToSignIn);

    const timer = setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 250);
    }, 2200);
    activeToast = { el: toast, timer };
  }

  function wishlistKey() {
    const id = window.Decus && window.Decus.customerId;
    return id ? ('decus_wishlist_' + id) : null;
  }
  function getWishlist() {
    const key = wishlistKey();
    if (!key) return [];
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }
  function setWishlist(items) {
    const key = wishlistKey();
    if (!key) return;
    try { localStorage.setItem(key, JSON.stringify(items)); } catch (e) {}
  }
  function isSaved(id) {
    return getWishlist().some(item => item.id === id);
  }
  function updateWishlistBadge() {
    const count = (window.Decus && window.Decus.customerLoggedIn) ? getWishlist().length : 0;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = count; });
  }
  function syncHeartButtons() {
    document.querySelectorAll('.wishlist[data-product-id]').forEach(btn => {
      const saved = !!(window.Decus && window.Decus.customerLoggedIn && isSaved(btn.dataset.productId));
      btn.classList.toggle('is-saved', saved);
      btn.textContent = saved ? '♥' : '♡';
    });
  }

  document.querySelectorAll('.wishlist[data-product-id]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!(window.Decus && window.Decus.customerLoggedIn)) {
        showSignInToast(btn);
        return;
      }
      const id = btn.dataset.productId;
      if (!id) return;
      let items = getWishlist();
      if (items.some(item => item.id === id)) {
        items = items.filter(item => item.id !== id);
      } else {
        items.push({
          id: id,
          handle: btn.dataset.productHandle || '',
          title: btn.dataset.productTitle || '',
          url: btn.dataset.productUrl || '',
          image: btn.dataset.productImage || '',
          price: btn.dataset.productPrice || ''
        });
      }
      setWishlist(items);
      syncHeartButtons();
      updateWishlistBadge();
      renderWishlistPage();
    });
  });

  syncHeartButtons();
  updateWishlistBadge();

  // Renders the saved-items grid on the dedicated Wishlist page (a no-op on
  // every other page, since #wishlist-grid only exists there).
  function renderWishlistPage() {
    const grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    const signedOutMsg = document.getElementById('wishlist-signed-out');
    const emptyMsg = document.getElementById('wishlist-empty');
    const loggedIn = window.Decus && window.Decus.customerLoggedIn;

    if (!loggedIn) {
      grid.hidden = true;
      if (emptyMsg) emptyMsg.hidden = true;
      if (signedOutMsg) signedOutMsg.hidden = false;
      return;
    }
    if (signedOutMsg) signedOutMsg.hidden = true;

    const items = getWishlist();
    if (!items.length) {
      grid.hidden = true;
      if (emptyMsg) emptyMsg.hidden = false;
      return;
    }
    if (emptyMsg) emptyMsg.hidden = true;
    grid.hidden = false;

    const esc = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

    grid.innerHTML = items.map(item => `
      <article class="product-card">
        <div class="product-media">
          <a href="${esc(item.url)}" aria-label="View ${esc(item.title)}">
            ${item.image ? `<img src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy">` : `<div class="product-placeholder">DECUS</div>`}
          </a>
          <button class="wishlist is-saved" type="button" data-remove-id="${esc(item.id)}" aria-label="Remove ${esc(item.title)} from wishlist">♥</button>
        </div>
        <div class="product-info">
          <a class="product-title" href="${esc(item.url)}">${esc(item.title)}</a>
          <div class="price">${esc(item.price)}</div>
        </div>
      </article>
    `).join('');

    grid.querySelectorAll('[data-remove-id]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const id = btn.dataset.removeId;
        setWishlist(getWishlist().filter(i => i.id !== id));
        updateWishlistBadge();
        renderWishlistPage();
      });
    });
  }
  renderWishlistPage();

  const recoverLink = document.getElementById('RecoverPasswordLink');
  const recoverForm = document.getElementById('RecoverPasswordForm');
  if (recoverLink && recoverForm) {
    recoverLink.addEventListener('click', (e) => {
      e.preventDefault();
      recoverForm.classList.add('is-open');
      recoverForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    if (recoverForm.querySelector('.form-message')) recoverForm.classList.add('is-open');
  }

  document.querySelectorAll('[data-address-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = document.getElementById(btn.dataset.addressToggle);
      if (target) target.classList.toggle('is-open');
    });
  });

  // Product gallery zoom — hover-pan on desktop, tap-to-fullscreen on touch.
  const lightbox = document.querySelector('[data-zoom-lightbox]');
  const lightboxImg = document.querySelector('[data-zoom-lightbox-img]');
  const lightboxClose = document.querySelector('[data-zoom-close]');

  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';
  }
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightbox) lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLightbox(); });

  document.querySelectorAll('[data-zoom-item]').forEach(item => {
    const img = item.querySelector('.product-gallery-img');
    const pane = item.querySelector('[data-zoom-pane]');
    if (!img) return;

    item.addEventListener('mousemove', (e) => {
      if (!pane) return;
      const rect = item.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      pane.style.backgroundPosition = `${x}% ${y}%`;
      item.classList.add('is-zooming');
    });
    item.addEventListener('mouseleave', () => item.classList.remove('is-zooming'));

    img.addEventListener('click', () => openLightbox(img.dataset.zoomSrc || img.src, img.alt));
  });

  // Instagram feed CTA — the Square Instagram Feed app injects its widget as
  // a fixed sibling right after <main>, outside our normal section flow, so
  // we can't position a theme section below it directly. Instead, watch for
  // the widget to mount and drop our "View More on Instagram" link right
  // after it, so the CTA reads as part of the same block instead of a
  // separate section above or below.
  (function () {
    const IG_URL = 'https://www.instagram.com/shopdecus/';
    let inserted = false;
    function insertCta(widget) {
      if (inserted || !widget) return;
      if (widget.nextElementSibling && widget.nextElementSibling.classList.contains('social-cta-only')) { inserted = true; return; }
      inserted = true;
      const wrap = document.createElement('div');
      wrap.className = 'social-cta-only';
      const link = document.createElement('a');
      link.className = 'btn';
      link.href = IG_URL;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'View More on Instagram →';
      wrap.appendChild(link);
      widget.insertAdjacentElement('afterend', wrap);
    }
    const existing = document.querySelector('.Vtl-InstaFeedWrappperClass');
    if (existing) {
      insertCta(existing);
    } else {
      const observer = new MutationObserver(() => {
        const widget = document.querySelector('.Vtl-InstaFeedWrappperClass');
        if (widget) { insertCta(widget); observer.disconnect(); }
      });
      observer.observe(document.body, { childList: true });
      setTimeout(() => observer.disconnect(), 15000);
    }
  })();
});
